export default __webpack_public_path__ + "static/media/coincoin.08416eff.png";